import { Authorized } from '@/react/hooks/useUser';
import { RefreshImageStatusButton } from '@/react/docker/components/ImageStatus/RefreshImageStatusButton';

import { AddButton } from '@@/buttons';
import { DeleteButtonWithRemoveVolume } from '@@/buttons/DeleteButtonWithRemoveVolume';

import { DecoratedStack } from './types';

export function TableActions({
  selectedItems,
  onRemove,
}: {
  selectedItems: Array<DecoratedStack>;
  onRemove: (items: Array<DecoratedStack>, removeVolumes: boolean) => void;
}) {
  return (
    <div className="flex items-center gap-2">
      <RefreshImageStatusButton resourceType="stack" size="md" />
      <Authorized authorizations="PortainerStackDelete">
        <DeleteButtonWithRemoveVolume
          disabled={selectedItems.length === 0}
          onConfirmed={(removeVolumes) =>
            onRemove(selectedItems, removeVolumes)
          }
          confirmMessage="Do you want to remove the selected stack(s)? Associated services will be removed as well."
          data-cy="stack-removeStackButton"
        />
      </Authorized>

      <Authorized authorizations="PortainerStackCreate">
        <AddButton data-cy="stack-addStackButton" to=".newstack">
          Add stack
        </AddButton>
      </Authorized>
    </div>
  );
}
